import React from 'react';
import { Box, Heading, Stack } from '@99designs/emu';
import PageLayout from '../../PageLayout';

interface LayoutProps {
    children: React.ReactNode;
    heading?: string;
    designFigure?: JSX.Element;
}

export function Layout({ children, heading, designFigure }: LayoutProps) {
    return (
        <PageLayout>
            {designFigure && <Box>{designFigure}</Box>}
            <Stack space="2bu">
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="baseline"
                    justifyContent="stretch"
                >
                    {heading && (
                        <Heading appearanceLevel={1} accessibilityLevel={1} withDivider>
                            {heading}
                        </Heading>
                    )}
                </Box>
                {children}
            </Stack>
        </PageLayout>
    );
}
